module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/6393ad802cd258d0fd8dfc78d94f3829.png";